import { HubFeature } from '@ats/api/cm';
import { LocDefs, MapLocKeys } from '@cm/core/localization';

const dpRoot = 'History|Exams';

export type ExamActionsLoc =
	| 'CPExamActionsScoreReportDownloadButton'
	| 'CPExamActionsCriteriaButton';

export const cpExamActionsLocs: LocDefs<ExamActionsLoc> = {
	CPExamActionsScoreReportDownloadButton: {
		defaultValue: 'Download score report',
		description: 'Button to download the score report',
		displayPath: `${dpRoot}|Download Score Report`,
		displayType: 'Button',
		htmlAllowed: false,
		shared: false,
		feature: HubFeature.ExamScoreReports,
		portal: 'CP',
		legacyName: 'Exam.ScoreReports/History.Exams.Button.DownloadScoreReport',
	},
	CPExamActionsCriteriaButton: {
		defaultValue: 'Criteria',
		displayPath: `${dpRoot}|Criteria`,
		description: `Accessibility label for the criteria button.`,
		displayType: 'Button',
		htmlAllowed: false,
		shared: false,
		feature: HubFeature.ExamInformationUrl,
		portal: 'CP',
		legacyName: 'Exam.InformationUrl/History.Exams.Button.Criteria',
	},
};

export const LOC_KEYS = MapLocKeys<ExamActionsLoc>(cpExamActionsLocs);
export type CPExamActionsLocKeys = typeof LOC_KEYS;
